<template>
	<div class="toasts pointer-events-none fixed inset-x-0 z-[95] flex flex-col items-center gap-2 px-4" aria-live="polite">
		<TransitionGroup name="toast">
			<div
				v-for="t in toasts"
				:key="t.id"
				class="pointer-events-auto flex w-full max-w-md items-center gap-3 rounded-2xl px-4 py-3 text-[15px] font-semibold shadow-lg"
				:class="t.tone === 'error' ? 'bg-sale text-bg' : 'bg-ink text-bg'"
				role="status"
			>
				<span class="min-w-0 flex-1">{{ t.message }}</span>
				<router-link v-if="t.action?.to" :to="t.action.to" class="min-h-tap flex items-center font-extrabold underline" @click="dismiss(t.id)">
					{{ t.action.label }}
				</router-link>
				<button v-else-if="typeof t.action?.handler === 'function'" type="button" class="min-h-tap flex items-center font-extrabold underline" @click="runAction(t)">
					{{ t.action.label }}
				</button>
			</div>
		</TransitionGroup>
	</div>
</template>

<script>
import { toasts, dismissToast } from '@/lib/toast'

export default {
	data() {
		return { toasts }
	},
	methods: {
		runAction(t) {
			dismissToast(t.id)
			t.action.handler()
		},
		dismiss(id) {
			dismissToast(id)
		},
	},
}
</script>

<style scoped>
.toasts {
	bottom: calc(var(--kb) + max(var(--tabbar-space), calc(var(--dock-bottom) + var(--dock-h))) + 12px);
}
.toast-enter-active,
.toast-leave-active {
	transition: all 0.2s ease;
}
.toast-enter-from,
.toast-leave-to {
	opacity: 0;
	transform: translateY(12px);
}
</style>
